export default __webpack_public_path__ + "static/media/photo-2.db50c5a1.jpg";